import Cookies from "js-cookie";

export const cookieKeys = {
  token: "@token",
  refreshToken: "@refreshToken",
  cpf: "@cpf",
  cnpj: "@cnpj",
  dtNasc: "@dtNasc",
  email: "@email",
  accessTokenMfa: "@accessTokenMfa",
  idCorretor: "@idCorretor",
  usuarioId: "@usuarioId",
};

export const setCookie = (key: string, value: string) => {
  Cookies.set(key, value, {
    expires: 1,
    secure: true,
    sameSite: "strict",
  });
};

export const getCookie = (key: string) => Cookies.get(key);

export const removeCookie = (key: string) => Cookies.remove(key);
